/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ok fresh; stale: the collector has not written for a minute; collecting: nothing yet; disabled: NODE_MONITOR_ENABLED=false; redis_unavailable.
 * @export
 * @enum {string}
 */

export enum OpsInfrastructureState {
    Ok = 'ok',
    Stale = 'stale',
    Collecting = 'collecting',
    Disabled = 'disabled',
    RedisUnavailable = 'redis_unavailable'
}



